export default __webpack_public_path__ + "static/media/map_disabled.00831b1f.svg";